/**
* @desc 时间方法
* @example 调用示例
*   函数调用 this.$timeTransfer.timeStampToSeconds()
*   函数调用 this.$timeTransfer.timeStampToOther()
    管道符调用 | thousandBitSeparator
**/

import Vue from 'vue'
import moment from 'moment'  // 日期格式化

// 时间戳转化精确到秒
const  timeStampToSeconds =  (value, formatString = 'YYYY-MM-DD HH:mm:ss' ) => {
  if(typeof value != 'number'){
    return ''
  }
  return moment(value).format(formatString);
}
const  timeStampToOther=  (value, formatString = 'yyyyMMddHHmmss' ) => {
  if(typeof value != 'number'){
    return ''
  }
  return moment(value).format(formatString);
}
// 将'20231109110738' 转换为 'YYYY-MM-DD HH:mm:ss'
const  timeStampToDate =  (value) => {
  let time =""
  if (value != "" && value != null) {
    time = value.slice(0, 4) + "-" + value.slice(4, 6) +
      "-" + value.slice(6, 8) + " " + value.slice(8, 10) +
      ":" + value.slice(10, 12) + ":" + value.slice(12, 14);
    return time;
  } else {
    return "暂无";
  }
}

// 时间戳转化精确天
const  timeStampToDay =  (value,formatString = 'YYYY-MM-DD' ) => {
  if(typeof value != 'number'){
    return ''
  }
  return moment(value).format(formatString);
}
// 时间戳转化精确到分钟
const timeStampToMinute = (value,formatString = 'YYYY-MM-DD HH:mm') => {
  if(typeof value != 'number'){
    return ''
  }
  return moment(value).format(formatString);
}
//将日期时间转化精确到毫秒
const timeToSeconds = (value) => {
  if(typeof value != 'string'){
    return ''
  }
  return moment(value,'YYYY-MM-DD HH:mm:ss').valueOf();
}
//  毫秒转天数
const timeToDay = (num) => {
  return num / 1000 /60 / 60 / 24
}
// 毫秒转天数
Vue.filter('timeToDay',timeToDay)

//格式化日期过滤器
Vue.filter('timeStampToSeconds',timeStampToSeconds)
Vue.filter('timeStampToOther',timeStampToOther)
Vue.filter('timeStampToDate',timeStampToDate)

//格式化日期到日
Vue.filter('timeStampToDay',timeStampToDay)

//格式化日期到分钟
Vue.filter('timeStampToMinute',timeStampToMinute)


export default {
  timeStampToSeconds,
  timeStampToDay,
  timeStampToMinute,
  timeToDay,
  timeToSeconds,
  timeStampToOther,
  timeStampToDate
}
// 时间搜索范围
export function addDateRange(params,dateRange){ 
      var search=params;
      search.startTime="";
      search.endTime="";
      dateRange=Array.isArray(dateRange)?dateRange:[]
      if(null!=dateRange&&''!=dateRange){
        search.startTime=this.dateRange[0];
        search.endTime=this.dateRange[1];
      }
      return search
}



